import { NgModule } from "@angular/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ApiClientService } from "~app/common/services/api-client.service";
import { WebinstallningarService } from "~app/common/services/webinstallningar/webinstallningar.service";
import {
    ProduktinstruktionerDetailsHeaderComponent
} from "./produktinstruktioner/produktinstruktioner-details/produktinstruktioner-details-header/produktinstruktioner-details-header.component";
import { ProduktinstruktionerDetailsComponent } from "./produktinstruktioner/produktinstruktioner-details/produktinstruktioner-details.component";
import { BegransningsmatrisComponent } from "./produktinstruktioner/produktinstruktioner-details/tabs/begransningsmatris/begransningsmatris.component";
import { FargmarkningComponent } from "./produktinstruktioner/produktinstruktioner-details/tabs/fargmarkning/fargmarkning.component";
import { FordelningsmatrisComponent } from "./produktinstruktioner/produktinstruktioner-details/tabs/fordelningsmatris/fordelningsmatris.component";
import { GrunddataComponent } from "./produktinstruktioner/produktinstruktioner-details/tabs/grunddata/grunddata.component";
import { RestriktionerComponent } from "./produktinstruktioner/produktinstruktioner-details/tabs/restriktioner/restriktioner.component";
import { StolpComponent } from "./produktinstruktioner/produktinstruktioner-details/tabs/stolp/stolp.component";
import { VardematrisComponent } from "./produktinstruktioner/produktinstruktioner-details/tabs/vardematris/vardematris.component";
import { ProduktinstruktionerDownloadComponent } from "./produktinstruktioner/produktinstruktioner-download/produktinstruktioner-download.component";
import { ProduktinstruktionerHistorikComponent } from "./produktinstruktioner/produktinstruktioner-historik/produktinstruktioner-historik.component";
import {
    ProduktinstruktionerMasseditHeaderComponent
} from "./produktinstruktioner/produktinstruktioner-massedit/produktinstruktioner-massedit-header/produktinstruktioner-massedit-header.component";
import { ProduktinstruktionerMassEditComponent } from "./produktinstruktioner/produktinstruktioner-massedit/produktinstruktioner-massedit.component";
import { ProduktinstruktionerSearchResultComponent } from "./produktinstruktioner/produktinstruktioner-search-result/produktinstruktioner-search-result.component";
import { ProduktinstruktionerSearchComponent } from "./produktinstruktioner/produktinstruktioner-search/produktinstruktioner-search.component";
import { ProduktinstruktionerComponent } from "./produktinstruktioner/produktinstruktioner.component";
import { ProduktionsmalMatrisComponent } from "./produktionsmal/produktionsmal-matris/produktionsmal-matris.component";
import { ProduktionsmalComponent } from "./produktionsmal/produktionsmal.component";
import { ProduktionsmalService } from "./produktionsmal/services/produktionsmal.service";
import { SandningloggComponent } from "./sandninglogg/sandninglogg.component";
import { SearchPanelMaskinComponent } from "./sandninglogg/search-panel-maskin/search-panel-maskin.component";
import { SearchPanelComponent } from "./sandninglogg/search-panel/search-panel.component";
import { SearchResultMaskinComponent } from "./sandninglogg/search-result-maskin/search-result-maskin.component";
import { SearchResultComponent } from "./sandninglogg/search-result/search-result.component";

@NgModule({
    imports: [
        RaskCommonModule,
        SandningloggComponent,
        SearchPanelComponent,
        SearchResultComponent,
        SearchPanelMaskinComponent,
        SearchResultMaskinComponent,
        ProduktionsmalComponent,
        ProduktionsmalMatrisComponent,
        ProduktinstruktionerComponent,
        ProduktinstruktionerSearchComponent,
        ProduktinstruktionerSearchResultComponent,
        ProduktinstruktionerDetailsComponent,
        ProduktinstruktionerDetailsHeaderComponent,
        GrunddataComponent,
        VardematrisComponent,
        FordelningsmatrisComponent,
        FargmarkningComponent,
        BegransningsmatrisComponent,
        StolpComponent,
        RestriktionerComponent,
        ProduktinstruktionerMassEditComponent,
        ProduktinstruktionerMasseditHeaderComponent,
        ProduktinstruktionerDownloadComponent,
        ProduktinstruktionerHistorikComponent
    ],
    providers: [
        BusyService,
        ProduktionsmalService,
        WebinstallningarService,
        ApiClientService
    ]
})
export class ProduktionModule { }
